import React, {Fragment, useEffect, useState} from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import {useMutation} from "react-query";
import {Dialog, Transition} from '@headlessui/react'
import {Field, Formik} from "formik";

import {inviteStudents} from "../../api/students";
import Partials from "../partials";
import Fields from "../formFields";
import UTILS from "../../utils";
import {useParams} from "react-router-dom";
import { sortBy } from "lodash";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const BlockClassInvite = ({ students, onInviteSuccess }) => {
  const [studentList, _setStudentList] = useState([]);
  const [editingStudent, _seEditingStudent] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const params = useParams();
  const classId = params.classId;
  const history = useHistory();

  useEffect(() => {
    const newStudentsList = students.map((student) => {
      const isSelected =
        studentList.find((stu) => stu.id === student.id)?.isSelected || false;

      return { ...student, isSelected };
    });

    _setStudentList(newStudentsList);
  }, [students]);

  const closeModal = () => {
    setIsOpen(false);
    _seEditingStudent({});
  };

  const openModal = (student) => {
    setIsOpen(true);
    _seEditingStudent(student);
  };

  const toggleStudentSelection = (studentId) => {
    if (isLoading) return;

    const newStudentsList = studentList.map((student) => {
      if (student.id === studentId)
        return { ...student, isSelected: !student.isSelected };

      return student;
    });

    _setStudentList(newStudentsList);
  };

  const handleSubmit = (values) => {
    const newStudentList = studentList.map((student) => {
      if (student.id === values.id) return { ...values };

      return student;
    });

    _setStudentList(newStudentList);
    closeModal();
  };

  const { isLoading, error, isError, mutate, data } = useMutation(
    inviteStudents,
    {
      onSuccess: (data) => {
        const noOfStudentInvited = studentList.filter(
          (student) => student.isSelected
        );
        onInviteSuccess?.(noOfStudentInvited.length);
      },
      onError: (err) => {
        alert(
          "We are having problem inviting students. Please try again later."
        );
        console.log(err);
      },
    }
  );

  const handleClick = () => {
    if (isLoading) return;

    const selectedStudents = studentList.filter(
      (student) => student.isSelected
    );

    if (!selectedStudents.length) {
      alert("Please select at least 1 student to invite.");
      return;
    }

    mutate({ classId: classId, students: selectedStudents });
  };

  const checkSelectedState = (studentList) => {
    return studentList.every((obj) => obj.isSelected);
  };

  const handleSelectAll = (currentStatus) => {
    const newStudentList = studentList.map((student) => ({
      ...student,
      isSelected: !currentStatus,
    }));

    _setStudentList(newStudentList);
  };

  const navigateToEditStudent = () => {
    history.push(`/class/${classId}/edit-students`);
  };
  return (
    <>
      <ul className={"Blocks BlockClassInvite px-2"}>
        <li
          className={
            "flex justify-between md:bg-zinc-200 p-3 rounded-lg md: gap-10"
          }
        >
          <div
            className={"flex-none font-['Poppins-SemiBold'] md:pr-4 w-[65px]"}
          >
            Sr. No
          </div>
          <div className="flex-1 font-['Poppins-SemiBold']">Name</div>
          <div
            className="font-['Poppins-Bold']"
            onClick={() => handleSelectAll(checkSelectedState(studentList))}
          >
            <span
              className={`icon icon-check-square text-xl ${
                checkSelectedState(studentList)
                  ? "text-green-500"
                  : "text-zinc-400"
              } cursor-pointer`}
            ></span>
          </div>
        </li>
        <li className="list-none">
          <div className="max-h-96 overflow-auto">
            <ul>
              {studentList.length > 0 &&
                sortBy(studentList, ["first_name"]).map((student, index) => (
                  <li
                    key={"student-list" + index}
                    className={
                      "flex justify-between p-3 rounded-lg md: gap-10 rounded-lg shadow my-4 cursor-pointer"
                    }
                  >
                    <div className={" w-[65px] flex-none md:pr-4 text-center"}>
                      {index + 1}
                    </div>
                    <div className="flex-1 truncate hover:text-clip capitalize">
                      {student.first_name} {student.last_name}
                    </div>
                    <div className="flex gap-3">
                      <button onClick={() => openModal(student)}>
                        <span className="icon icon-edit-2 text-zinc-400 text-xl"></span>
                      </button>
                      <button>
                        <span
                          onClick={() => toggleStudentSelection(student.id)}
                          className={`icon icon-check-square text-xl ${
                            student.isSelected
                              ? "text-green-500"
                              : "text-zinc-400"
                          }`}
                        ></span>
                      </button>
                    </div>
                  </li>
                ))}
            </ul>
          </div>
        </li>
      </ul>

      <div
        className={
          "bg-black rounded-lg mx-auto my-12 border-lg h-1 w-2/12 invisible md:visible"
        }
      ></div>

      <button
        onClick={handleClick}
        className={
          "flex justify-center items-center w-full md:w-4/5  bg-black text-white mx-auto my-8  shadow rounded-lg  p-3 mb-6 text-lg"
        }
      >
        {isLoading ? (
          <Partials.PartialLoading />
        ) : (
          <span className={"icon icon-mail mr-4 text-2xl"}></span>
        )}
        <span>Send invite link via Email</span>
      </button>
      <div className="w-full flex justify-center item-center">
        <span className="text-center">OR</span>
      </div>
      <div className="mt-2">
        <button
          onClick={() => navigateToEditStudent()}
          className={
            "flex justify-center items-center text-black m-auto  shadow rounded-lg  p-3 mb-6 text-lg"
          }
        >
          <span className="text-sm">Add/Edit Student</span>
        </button>
      </div>

      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-10 overflow-y-auto"
          onClose={closeModal}
        >
          <div className="min-h-screen px-4 text-center">
            <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="inline-block w-full max-w-xl p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                <Dialog.Title
                  as="h3"
                  className="text-xl font-['Poppins-Bold'] leading-6 text-gray-900"
                >
                  Edit student details
                </Dialog.Title>
                <div className="mt-2">
                  <Formik
                    initialValues={editingStudent}
                    validationSchema={UTILS.forms.editStudentDetailsSchema}
                    onSubmit={handleSubmit}
                  >
                    {({ values, handleSubmit, isSubmitting }) => (
                      <form onSubmit={handleSubmit} className="pt-2 md:pt-6">
                        <div
                          key={"add-students-to-class"}
                          className="grid grid-cols-10 gap-1 md:gap-2 mb-4 border-b lg:border-b-0"
                        >
                          <div
                            className={
                              "col-start-1 md:col-start-0 col-span-10 sm:col-span-5 md:col-span-2"
                            }
                          >
                            <Field
                              type={"text"}
                              name={`first_name`}
                              wrapperClasses={"mb-0"}
                              placeholder="First Name"
                              component={Fields.FieldInput}
                            />
                          </div>
                          <div
                            className={
                              "col-start-1 md:col-start-0 col-span-10  sm:col-span-5 md:col-span-2"
                            }
                          >
                            <Field
                              type={"text"}
                              name={`last_name`}
                              wrapperClasses={"mb-0"}
                              placeholder="Last Name"
                              component={Fields.FieldInput}
                            />
                          </div>
                          <div
                            className={
                              "col-start-1 md:col-start-0 order-2 lg:order-1 col-span-10 md:col-span-3"
                            }
                          >
                            <Field
                              type={"text"}
                              name={`mobile_number`}
                              wrapperClasses={"mb-0"}
                              placeholder="Mobile number"
                              component={Fields.FieldInput}
                            />
                          </div>
                          <div
                            className={
                              "col-start-1 md:col-start-0 order-1 lg:order-2 col-span-10 md:col-span-3"
                            }
                          >
                            <Field
                              type={"email"}
                              name={`email`}
                              wrapperClasses={"mb-0"}
                              placeholder="Email Id"
                              component={Fields.FieldInput}
                            />
                          </div>
                        </div>
                        <div className="mt-4 flex justify-end">
                          <button
                            type="button"
                            className="inline-flex justify-center px-8 py-2 text-sm font-medium text-zinc-900 bg-transparent border-2 border border-zinc-200 rounded-md hover:bg-zinc-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-zinc-500"
                            onClick={closeModal}
                          >
                            Cancel
                          </button>
                          <button
                            type="submit"
                            className="ml-2 inline-flex justify-center px-8 py-2 text-sm font-medium text-white bg-black border border-transparent rounded-md hover:bg-zinc-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-zinc-500"
                          >
                            Save
                          </button>
                        </div>
                      </form>
                    )}
                  </Formik>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default React.memo(BlockClassInvite, (pp, np) => _.isEqual(pp, np));

BlockClassInvite.propTypes = {
    students: PropTypes.array,
    onInviteSuccess: PropTypes.func
}
